<script setup>
import { computed } from "vue";
import store from "@/store/index";
import { GET_USER_DATA } from "@/store/getters/user";
import { getProfessionalProfileFields } from "@/utils/professional_profile_fields";
import { getDisplayRoleName } from "@/utils/permissions";
import Labelledfield from "@/components/utils/LabelledField";

const userData = computed(() => store.getters[GET_USER_DATA]);

const professionalFields = computed(() =>
  getProfessionalProfileFields(userData.value)
);

const displayRole = computed(() =>
  getDisplayRoleName(userData.value?.profile?.role_name)
);
</script>

<template>
  <v-card v-if="professionalFields.length" rounded="lg" outlined class="mb-4">
    <v-card-subtitle class="font-weight-bold primary--text pb-0 pt-3">
      <v-icon small left>mdi-certificate</v-icon>
      Professional registration — {{ displayRole }}
    </v-card-subtitle>
    <v-card-text>
      <v-row dense>
        <v-col
          v-for="(item, index) in professionalFields"
          :key="index"
          cols="12"
          md="6"
        >
          <Labelledfield :label="item.label">
            <v-text-field
              outlined
              dense
              :value="item.value"
              hide-details="auto"
              class="text-field-background"
              :readonly="item.readonly"
              :disabled="item.readonly"
            />
          </Labelledfield>
        </v-col>
      </v-row>
      <v-alert type="info" text dense class="mb-0 mt-1 text-caption">
        Registration details are managed by the county. Contact your sub-county office to update licence or registration numbers.
      </v-alert>
    </v-card-text>
  </v-card>
</template>
